import {useState} from "react";
import {Button, Form, Input, Modal, Typography} from "antd";
import {showErrorModal, showMessageModal} from "../../Services/ModalServices";
import AxiosServices from "../../Services/axiosServices"; // si tu veux afficher des modaux

const {Text} = Typography;

interface ForgotPasswordModalProps {
    open: boolean;
    onClose: () => void;
}

export default function ForgotPasswordModal({
                                                open,
                                                onClose,
                                            }: ForgotPasswordModalProps) {
    const [email, setEmail] = useState("");
    const [sent, setSent] = useState(false);

    const onSubmit = async () => {
        try {
            const result = await AxiosServices.forgotPassword(email);
            if (result.error) {
                showErrorModal(result.error);
                return;
            }
            setSent(true);
            showMessageModal("Si un compte existe, un email a été envoyé avec un lien de réinitialisation.");
        } catch (e: any) {
            showErrorModal(e?.message ?? "Erreur lors de la demande de réinitialisation.");
        } finally {
            setEmail("");
            setSent(false);
        }

    };

    return (
        <Modal
            open={open}
            onCancel={onClose}
            footer={null}
            title="Mot de passe oublié"
            centered
        >
            {sent ? (
                <Text>
                    Si un compte existe pour <b>{email}</b>, un email a été envoyé.
                </Text>
            ) : (
                <Form layout="vertical" onFinish={onSubmit}>
                    <Form.Item
                        label="Email"
                        name="email"
                        rules={[
                            {required: true, message: "Veuillez entrer votre email"},
                            {type: "email", message: "Adresse email invalide"},
                        ]}
                    >
                        <Input
                            type="email"
                            value={email}
                            onChange={(e) => {
                                console.log('targe', e.target.value);
                                setEmail(e.target.value)
                                }
                            }
                        />
                    </Form.Item>
                    <Button type="primary" htmlType="submit" block>
                        Envoyer le lien de réinitialisation
                    </Button>
                </Form>
            )}
        </Modal>
    );
}
